import i18n from 'services/base/i18n';

export default {
  // Save button to change the password
  save: () => i18n.pgettext('Pages|Accounts|Change Password', 'SAVE'),
  // Label for the input box where the user inputs his old password
  oldPassword: () => i18n.pgettext('Pages|Accounts|Change Password', 'OLD PASSWORD'),
  // Label for the input box where the user inputs his new password
  newPassword: () => i18n.pgettext('Pages|Accounts|Change Password', 'NEW PASSWORD'),
  // Label for the input box where the user inputs his new password again
  confirmPassword: () => i18n.pgettext('Pages|Accounts|Change Password', 'CONFIRM PASSWORD'),
};
